var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAkarIconPlusl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0.916748C5.43124 0.916748 0.916656 5.43133 0.916656 11.0001C0.916656 16.5688 5.43124 21.0834 11 21.0834C16.5687 21.0834 21.0833 16.5688 21.0833 11.0001C21.0833 5.43133 16.5687 0.916748 11 0.916748ZM11.9167 14.6667C11.9167 14.9099 11.8201 15.143 11.6482 15.3149C11.4763 15.4868 11.2431 15.5834 11 15.5834C10.7569 15.5834 10.5237 15.4868 10.3518 15.3149C10.1799 15.143 10.0833 14.9099 10.0833 14.6667V11.9167H7.33332C7.09021 11.9167 6.85705 11.8202 6.68514 11.6483C6.51323 11.4764 6.41666 11.2432 6.41666 11.0001C6.41666 10.757 6.51323 10.5238 6.68514 10.3519C6.85705 10.18 7.09021 10.0834 7.33332 10.0834H10.0833V7.33342C10.0833 7.0903 10.1799 6.85714 10.3518 6.68523C10.5237 6.51333 10.7569 6.41675 11 6.41675C11.2431 6.41675 11.4763 6.51333 11.6482 6.68523C11.8201 6.85714 11.9167 7.0903 11.9167 7.33342V10.0834H14.6667C14.9098 10.0834 15.1429 10.18 15.3148 10.3519C15.4867 10.5238 15.5833 10.757 15.5833 11.0001C15.5833 11.2432 15.4867 11.4764 15.3148 11.6483C15.1429 11.8202 14.9098 11.9167 14.6667 11.9167H11.9167V14.6667Z",
    fill: "#A5A7B2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkarIconPlusl);
export default __webpack_public_path__ + "static/media/akar-icon-plusl.95e5651e674b96c238a53d7f33044a64.svg";
export { ForwardRef as ReactComponent };